var btt = document.getElementById("backtotop");

btt.addEventListener('click', () => {
    window.scrollTo({
        behavior: 'smooth',
        top: 0,
        left: 0
    })
});